/**
 * Production-safe logger — only outputs in non-production environments.
 * Use this instead of bare console.log/warn/error throughout the app.
 */
const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  log:   (...args) => { if (isDev) console.log(...args); },    // eslint-disable-line no-console
  warn:  (...args) => { if (isDev) console.warn(...args); },   // eslint-disable-line no-console
  error: (...args) => { if (isDev) console.error(...args); },  // eslint-disable-line no-console
  debug: (...args) => { if (isDev) console.debug(...args); },  // eslint-disable-line no-console
};

export default logger;
